export function About() {
  return (
    <section className="about" id="about">
      <div className="about__inner">
        <div className="about__left">
          <p className="section-eyebrow">About Us</p>
          <h2 className="section-title">A firm built on<br /><em>integrity &amp; expertise</em></h2>
          <div className="about__pillars">
            {['Integrity', 'Precision', 'Confidentiality'].map((p) => (
              <span className="about__pillar" key={p}>{p}</span>
            ))}
          </div>
        </div>
        <div className="about__right">
          <p className="about__body">
            Founded in 2018, Prabhu Mallya &amp; Associates is a full-service Chartered
            Accountancy firm with offices in Mangaluru & Bengaluru, Karnataka. We serve a diverse
            clientele ranging from salaried individuals to mid-sized enterprises and
            listed companies.
          </p>
          <p className="about__body">
            Our team of qualified CAs and finance professionals brings deep domain
            knowledge across taxation, audit, and financial advisory. We believe that
            great financial advice isn't just about numbers — it's about building a
            long-term relationship grounded in trust.
          </p>
          <div className="about__credentials">
            <div className="about__credential">
              <span className="about__credential-icon">✦</span>
              <span>End-to-end advisory, litigation & support services</span>
            </div>
            <div className="about__credential">
              <span className="about__credential-icon">✦</span>
              <span>Expertise acorss India and USA regulations</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
